import { bonusPromotionsActions } from '../../../store/slices/bonusPromotions/slice';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { toastActions } from '../../../store/slices/toast/slice';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

// Message example
// {"canceled":{"id":"186742501","cancelReason":"Flapper issue","cancelCode":"1041","seq":13}}

export class CoreCancelledGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Canceled;

  public process(_message: GameCommunicationMessageType): void {
    this.store.dispatch(toastActions.createToast('TOAST_GAME_CANCELLED'));
    this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.GameCancelled));
    const isEligibleCampaign = Boolean(this.store.getState().bonusPromotions.eligibleBonusCampaign);
    if (isEligibleCampaign) {
      this.store.dispatch(bonusPromotionsActions.setRefetchCampaign(true));
    }
  }
}
